"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require('react');

var PropTypes = require('prop-types');

var PrintJob = require('../../PrintJob');

var Product = require('../../../products/interfaces/Product');

var Component = require('../../../products/interfaces/Component');

var ComponentFieldsListWrapper = require('./ComponentFieldsListWrapper');

var Highlight = require('./Highlight');

function PaperComponentDetails(props) {
  var fields = [{
    field: 'fileText',
    label: 'File:',
    el: 'span'
  }, {
    field: 'sizeText',
    label: 'Size:',
    el: 'span'
  }, {
    field: 'queueText',
    label: 'Queue:',
    el: 'span'
  }, {
    field: 'cutCodeText',
    label: 'Cut Code:',
    el: 'span'
  }, {
    field: 'orientationText',
    label: 'Orientation:',
    el: 'span'
  }, {
    field: 'paperText',
    label: 'Paper:',
    el: 'span'
  }, {
    field: props.variant === 'TestPrints' ? 'testPrintsQtyText' : 'qtyText',
    label: 'Qty:',
    el: 'span'
  }, {
    field: 'noteText',
    label: 'Note:',
    el: Highlight
  }];
  return /*#__PURE__*/React.createElement(ComponentFieldsListWrapper, _extends({}, props, {
    fields: fields
  }));
}

PaperComponentDetails.defaultProps = {
  variant: 'FullOrders'
};
PaperComponentDetails.propTypes = {
  printJob: PropTypes.instanceOf(PrintJob).isRequired,
  product: PropTypes.instanceOf(Product).isRequired,
  component: PropTypes.instanceOf(Component).isRequired,
  componentSettings: PropTypes.shape({
    "default": PropTypes.object.isRequired
  }).isRequired,
  options: PropTypes.any,
  variant: PropTypes.oneOf(['TestPrints', 'FullOrders'])
};
module.exports = PaperComponentDetails;